<template>
  <VButtonGroup>
    <VButton
      v-for="option in options"
      :key="option[valueKey]"
      :disabled="disabled"
      :theme="getValue === option[valueKey] ? 'primary' : 'default'"
      @click="selectOption(option)"
    >
      {{ option[labelKey] }}
    </VButton>
  </VButtonGroup>
</template>

<script>

import Core from "@/core/Core";

export default {
	name:     'VGroupButtonSelector',
	model:    {
		prop:  'modelValue',
		event: 'update:modelValue'
	},
	props:    {
		/**
		 * Возвращаемое значение
		 * @model
		 */
		modelValue: {
			type:     Object,
			required: true
		},
		/**
		 * Ключ объекта, по которому нужно возвращать в модель value, по умолчанию это поле `id`
		 */
		valueKey: {
			type:    String,
			default: 'id'
		},
		/**
		 * Ключ объекта, по которому нужно отображать текст в кнопках, по умолчанию это поле `name`
		 */
		labelKey: {
			type:    String,
			default: 'name'
		},
		/**
		 * Массив объектов, представляющих доступные варианты выбора
		 * Каждый объект должен содержать как минимум два поля:
		 * - id (или другое поле, указанное в valueKey) - уникальное значение для идентификации
		 * - name (или другое поле, указанное в labelKey) - отображаемое название
		 */
		options: {
			type:     Array,
			required: true
		},
		/** Флаг, блокирующий опции */
		disabled: {
			type:    Boolean,
			default: false
		}
	},
	emits:    ['update:modelValue'],
	computed: {
		getValue() {
			return this.modelValue[this.valueKey];
		},
	},
	methods:  {
		selectOption(option) {
			const updatedModel = Core.utils.cloneDeep(option);
			this.$emit('update:modelValue', updatedModel);
		}
	}
};
</script>
